import { datadogRum } from '@datadog/browser-rum';
import { datadogLogs } from '@datadog/browser-logs';

export const DataDogConfig = function () {

    
    datadogRum.init({
        applicationId: '225fe22e-f080-45aa-9a7b-54e98ce5b44f',
        clientToken: 'pub795c907206c085f5a3f33432c0510d81',
        // applicationId: process.env['DDAPPLICATIONID']!,
        // clientToken: process.env['DDCLIENTTOKEN']!,
        // `site` refers to the Datadog site parameter of your organization
        // see https://docs.datadoghq.com/getting_started/site/
        site: 'datadoghq.com',
        service: 'bebe-ui',
        env: process.env['ENV'],
        // Specify a version number to identify the deployed version of your application in Datadog
        // version: '1.0.0',
        sessionSampleRate: 100,
        sessionReplaySampleRate: 100,
        defaultPrivacyLevel: 'mask-user-input',
    });

    datadogRum.startSessionReplayRecording();

    datadogLogs.init({
        // clientToken: process.env['DDCLIENTTOKEN']!,
        clientToken: 'pub795c907206c085f5a3f33432c0510d81',
        site: 'datadoghq.com',
        service: 'bebe-ui',
        forwardConsoleLogs: 'all',
        forwardErrorsToLogs: true,
        sessionSampleRate: 100
    });
}